import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { QuestionBase } from '../models/question-base';

@Injectable({
  providedIn: 'root'
})
export class QuestionControlService {
  toFormGroup(questions: QuestionBase[] ) {
    const group = {};
    questions.forEach(question => {
      group[question.key] = question.required ? new UntypedFormControl(question.value || null, Validators.required)
                                              : new UntypedFormControl(question.value || null);
    });
    return new FormGroup(group);
  }
}
